import { SelectDropDown } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * id of the multi select
   */
  id: PropTypes.string.isRequired,
  /**
   * Title of the field. Must be a FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * options of the multi select
   */
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  /**
   * Callback called when an option is selected
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Selected values
   */
  values: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  /**
   * validation errors messages
   */
  errors: PropTypes.arrayOf(PropTypes.string),
  /**
   * Class of the container wrapper
   */
  containerClassName: PropTypes.string,
  /**
   * Class to style the title
   */
  titleClassName: PropTypes.string,
  /**
   * Class to override default SelectDropDown styles
   */
  className: PropTypes.string,
  /**
   * Indicates if field is required
   */
  required: PropTypes.bool,
}

const defaultProps = {
  title: null,
  values: null,
  errors: [],
  containerClassName: '',
  titleClassName: '',
  className: '',
  required: false,
}

const getFlatennedOptions = (options) => {
  // normal options array
  if (!options?.[0]?.options) {
    return options
  }

  // grouped options
  const result = []

  options?.forEach((option) => {
    result.push(...option.options)
  })

  return result
}

function SingleInputSelect(props) {
  const {
    id,
    title,
    options,
    onChange,
    values,
    errors,
    containerClassName,
    titleClassName,
    required,
    className,
    ...rest
  } = props

  const toOption = useMemo(() => {
    const result = {}

    getFlatennedOptions(options)?.forEach((option) => {
      result[option.value] = option
    })

    return result
  }, [options])

  const selectedOption = toOption[values] ?? null

  return (
    <div className={clsx('mb-3', containerClassName)}>
      {title && (
        <p className={clsx('mb-2', titleClassName)}>
          <FormattedMessage id={title} />
          {required && <span className="font-size-regular text-color-danger">*</span>}
        </p>
      )}

      <SelectDropDown
        id={id}
        value={selectedOption}
        isClearable
        options={options}
        onChange={(option) => onChange(option?.value || null)} // if option is cleared should be null (undefined gets overwritten in the form)
        className={clsx(errors?.length && 'select-error-border', className)}
        {...rest}
      />

      {errors?.map((errorMessage) => (
        <div key={errorMessage} className="text-color-danger mt-2">
          {errorMessage}
        </div>
      ))}
    </div>
  )
}

SingleInputSelect.propTypes = propTypes
SingleInputSelect.defaultProps = defaultProps

export default SingleInputSelect
